import React, { useMemo } from 'react'
import { EditorContext } from '.'

const EditorProvider = ({ children, editorState, onChange }) => {
  const value = useMemo(
    () => ({
      editorState,
      onChange
    }),
    [editorState, onChange]
  )
  return (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
  )
}

export default EditorProvider
